import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="bg-silea-cream" data-testid="about-page">
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <p className="eyebrow text-silea-navy/60">Про SILÉA</p>
        <h1 className="font-serif-display text-5xl sm:text-7xl mt-4 text-silea-navy leading-[1.05] max-w-3xl">
          Італійська <span className="italic">мрія</span>,<br />українська ремісничість.
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-16">
          <div className="lg:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_9f46cec6-d33c-4d03-bbf8-7fcace4b7e00/artifacts/6ocbr3dx_Screenshot%202026-04-26%20at%2015.40.49.png"
              alt=""
              loading="lazy"
              decoding="async"
              className="w-full aspect-[3/4] object-cover"
            />
          </div>
          <div className="lg:col-span-7 lg:pt-12 space-y-6 text-silea-navy/80 leading-relaxed">
            <p className="font-serif-display italic text-2xl text-silea-navy">
              «Все минає — тренди, сезони, люди, але залишається відчуття себе, свого тіла, свого стану. Саме це відчуття вона шукає — і знаходить в SILÉA.»
            </p>
            <p>
              SILÉA — це купальники, що пам'ятають море. Ми обираємо тканини в Італії — ті самі, з яких шиють найдорожчі європейські колекції. Кожен крій тестується на десятках жінок, щоб посадка була ідеальною.
            </p>
            <p>
              А найголовніше — кожен елемент декору ми вшиваємо вручну. Кристали Swarovski, морські камінці, перлини, ваше ім'я або авторський мотив. Це не просто купальник — це ритуал, який ви забираєте з собою.
            </p>
            <p className="font-serif-display italic text-xl text-silea-navy mt-6">— Будь власною музою.</p>
          </div>
        </div>

        <div className="mt-16">
          <Link
            to="/products"
            data-testid="about-shop-cta"
            className="inline-flex items-center gap-3 bg-silea-navy text-white px-8 py-4 eyebrow hover:bg-silea-navy/90"
          >
            До колекції →
          </Link>
        </div>
      </section>
    </div>
  );
}
